<template>
  <el-row>
    <el-col :span="24">
      <el-card>
        <div slot="header" class="clearfix flex justify-between">
          <span>{{ $t('devServiceProvideView.title') }}</span>
        </div>

        <el-form :model="serviceProvideForm" label-width="120px">
          <el-form-item :label="$t('devServiceProvideView.implementType')" required>
            <el-select
              v-model="serviceProvideForm.queryModel"
              style="width:100%"
              :placeholder="$t('devServiceProvideView.implementTypePlaceholder')">
              <el-option value="1" :label="$t('devServiceProvideView.sqlMethod')"></el-option>
              <el-option value="3" :label="$t('devServiceProvideView.javaMethod')"></el-option>
              <el-option value="2" :label="$t('devServiceProvideView.procedureMethod')"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('devServiceProvideView.params')" required>
            <el-input
              v-model="serviceProvideForm.params"
              :placeholder="$t('devServiceProvideView.paramsPlaceholder')">
            </el-input>
          </el-form-item>

          <el-form-item 
            v-if="serviceProvideForm.queryModel == 1" 
            :label="$t('devServiceProvideView.sql')">
            <el-input
              type="textarea"
              :rows="15"
              v-model="serviceProvideForm.sql"
              :placeholder="$t('devServiceProvideView.sqlPlaceholder')">
            </el-input>
          </el-form-item>

          <el-form-item 
            v-if="serviceProvideForm.queryModel == 1" 
            :label="$t('devServiceProvideView.outputTemplate')">
            <el-input
              type="textarea"
              :rows="5"
              v-model="serviceProvideForm.template"
              :placeholder="$t('devServiceProvideView.outputTemplatePlaceholder')">
            </el-input>
          </el-form-item>

          <el-form-item 
            v-if="serviceProvideForm.queryModel == 2" 
            :label="$t('devServiceProvideView.procedure')">
            <el-input
              type="textarea"
              :rows="5"
              v-model="serviceProvideForm.proc"
              :placeholder="$t('devServiceProvideView.procedurePlaceholder')">
            </el-input>
          </el-form-item>

          <el-form-item 
            v-if="serviceProvideForm.queryModel == 3" 
            :label="$t('devServiceProvideView.javaCode')">
            <el-input
              type="textarea"
              :rows="20"
              v-model="serviceProvideForm.javaScript"
              :placeholder="$t('devServiceProvideView.javaCodePlaceholder')">
            </el-input>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'DevServiceProvideView',
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      serviceProvideForm: {
        flowComponent: 'devServiceProvideView',
        queryModel: '',
        params: '',
        sql: '',
        template: '',
        proc: '',
        javaScript: ''
      }
    }
  },
  watch: {
    serviceProvideForm: {
      deep: true,
      handler(newVal) {
        this.$emit('notify', newVal)
      }
    }
  },
  created() {
    console.log(this.index)
  }
}
</script>